
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools-directory",
      function () {
        return require("private-next-pages/schools-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools-directory"])
      });
    }
  